// c:\xampp\htdocs\miners-market-main\components\ConfirmationModal.js

export default function ConfirmationModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete", cancelText = "Cancel", type = "danger" }) {
    if (!isOpen) return null;

    const typeStyles = {
        danger: {
            confirmBg: "bg-red-500 hover:bg-red-600",
            icon: "fas fa-exclamation-triangle text-red-500",
            iconBg: "bg-red-100"
        },
        warning: {
            confirmBg: "bg-yellow-500 hover:bg-yellow-600",
            icon: "fas fa-exclamation-circle text-yellow-500",
            iconBg: "bg-yellow-100"
        },
        info: {
            confirmBg: "bg-blue-500 hover:bg-blue-600",
            icon: "fas fa-info-circle text-blue-500",
            iconBg: "bg-blue-100"
        }
    };

    const styles = typeStyles[type] || typeStyles.danger;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" onClick={onClose}>
            <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="p-6 text-center">
                    <div className={`mx-auto flex items-center justify-center h-16 w-16 rounded-full ${styles.iconBg} mb-4`}>
                        <i className={`${styles.icon} text-3xl`}></i>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
                    <p className="text-gray-500">{message}</p>
                </div>

                {/* Buttons */}
                <div className="px-6 py-4 bg-gray-50 rounded-b-2xl flex gap-3">
                    <button 
                        onClick={onClose}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 font-medium"
                    >
                        {cancelText}
                    </button>
                    <button 
                        onClick={onConfirm}
                        className={`flex-1 px-4 py-2 rounded-lg text-white font-medium ${styles.confirmBg}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}
